export const STATIC_NAME = {
	PASS: 'password',
};
